export interface BattlePassTier {
  tier: number;
  xpRequired: number; // cumulative XP to reach this tier
  freeReward: { type: 'gems' | 'resources' | 'cosmetic'; value: number | string };
  premiumReward: { type: 'cosmetic'; value: string } | null; // cosmetic id or null
}

export interface BattlePassState {
  seasonId: string;
  xp: number;
  tier: number;
  claimed: number[]; // tier numbers claimed (free track)
  claimedPremium: number[]; // tier numbers claimed (premium track)
  premium: boolean;
}

export const CURRENT_SEASON_ID = 's1';

export const DEFAULT_BATTLE_PASS: BattlePassState = {
  seasonId: CURRENT_SEASON_ID,
  xp: 0,
  tier: 0,
  claimed: [],
  claimedPremium: [],
  premium: false,
};

// 30 tiers, XP scaling: tier N needs 100 + 50*(N-1) XP cumulative
export function generateTiers(): BattlePassTier[] {
  const tiers: BattlePassTier[] = [];
  let cumulativeXp = 0;

  const freeRewards = [
    // Alternating gems and resources
    ...Array.from({ length: 30 }, (_, i) => {
      if (i % 3 === 0) return { type: 'gems' as const, value: 5 + Math.floor(i / 3) * 5 };
      if (i % 3 === 1) return { type: 'resources' as const, value: 500 * (i + 1) };
      return { type: 'gems' as const, value: 10 + Math.floor(i / 3) * 5 };
    }),
  ];

  const premiumCosmetics = [
    'frame_fire', null, 'badge_flame', null, null,
    'color_green', null, null, 'badge_crown', null,
    null, null, null, null, null,
    null, null, null, null, null,
    null, null, null, null, null,
    null, null, null, null, 'frame_shadow',
  ];

  for (let i = 0; i < 30; i++) {
    cumulativeXp += 100 + 50 * i;
    tiers.push({
      tier: i + 1,
      xpRequired: cumulativeXp,
      freeReward: freeRewards[i]!,
      premiumReward: premiumCosmetics[i] ? { type: 'cosmetic', value: premiumCosmetics[i]! } : null,
    });
  }
  return tiers;
}

export const BATTLE_PASS_TIERS = generateTiers();
